import YoungPersonWhereaboutView from './YoungPersonWhereaboutViewContainer';
export default YoungPersonWhereaboutView;
